import { axiosInstance } from './AxiosDefaults';

export const getAllRoles = (): Promise<any> => {
    return axiosInstance.get(
        `/roles`,
        {
            withCredentials: false,
            headers: { 'Content-Type': 'application/json' }
        }
    );
};
